import { Component } from '@angular/core';

@Component({
  selector: 'app-angle-down',
  imports: [],
  template: `
    <svg
      width="24"
      height="24"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6394 13.5208C10.5532 13.5212 10.4677 13.5044 10.3881 13.4714C10.3084 13.4383 10.2362 13.3897 10.1756 13.3283L5.80063 8.95333C5.71337 8.82567 5.67399 8.6713 5.68944 8.51744C5.70489 8.36358 5.77418 8.22012 5.88508 8.11236C5.99598 8.0046 6.14137 7.93946 6.29561 7.92843C6.44985 7.9174 6.60303 7.96119 6.72813 8.05208L10.6394 11.9371L14.5506 8.05208C14.674 7.97211 14.8206 7.93587 14.967 7.94916C15.1134 7.96245 15.2511 8.0245 15.358 8.12537C15.4649 8.22624 15.5349 8.36009 15.5566 8.50545C15.5784 8.65082 15.5508 8.7993 15.4781 8.92708L11.1031 13.3021C11.0448 13.3682 10.9736 13.4217 10.8938 13.4593C10.8141 13.4969 10.7275 13.5179 10.6394 13.5208Z"
        fill="currentColor"
      />
    </svg>
  `
})
export class AngleDownComponent {}
